import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import bindActionCreators from 'redux/es/bindActionCreators'
import { Divider, Form, Grid, Header, Icon, Table } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      change,
    },
    dispatch
  )
}

class ShortTexts extends React.Component {
  getShortTextsCompare() {
    const { shortTexts, change, form, targetField } = this.props
    return shortTexts.map((item, index) => (
      <Table.Row
        key={item.id}
        className={item.hasChanged ? 'changed' : 'unchanged'}
        onClick={() => {
          change('productPropertyNewText', targetField, item.newText)
          change(form, 'new_row', 'text')
        }}>
        <Table.Cell collapsing>
          <Icon
            size="small"
            name="chevron left"
            className={'hide-below-largemonitor'}
          />
          <Icon
            size="small"
            name="chevron up"
            className={'hide-above-largemonitor'}
          />
        </Table.Cell>
        <Table.Cell>
          <span className="new">{item.newText}</span>
          <br />
          {item.hasChanged && item.currentText}
        </Table.Cell>
        <Table.Cell className="wdid" textAlign="right">
          {item.id}
        </Table.Cell>
      </Table.Row>
    ))
  }

  getShortTexts() {
    const { shortTexts, change, form, targetField } = this.props
    return shortTexts.map((item) => (
      <Table.Row
        key={item.id}
        onClick={() => {
          change('productPropertyNewText', targetField, item.currentText)
          change(form, 'new_row', 'text')
        }}>
        <Table.Cell collapsing>
          <Icon
            size="small"
            name="chevron left"
            className={'hide-below-largemonitor'}
          />
          <Icon
            size="small"
            name="chevron up"
            className={'hide-above-largemonitor'}
          />
        </Table.Cell>
        <Table.Cell>{item.currentText}</Table.Cell>
        <Table.Cell collapsing>{item.id}</Table.Cell>
      </Table.Row>
    ))
  }

  render() {
    const { title, compare } = this.props
    return (
      <div>
        <Header as="h5" content={title} />
        <Table compact singleLine basic="very" className="spaced" selectable>
          <Table.Body
            children={
              compare ? this.getShortTextsCompare() : this.getShortTexts()
            }
          />
        </Table>
        <Divider hidden />
      </div>
    )
  }
}

ShortTexts = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShortTexts)

export default class ProductPropertyWinDeltaTexts extends React.Component {
  render() {
    const { product, compareProduct, form } = this.props

    const both = !!(product && compareProduct)
    const widthChanged = both && product.wd_width !== compareProduct.wd_width
    const heightChanged = both && product.wd_height !== compareProduct.wd_height
    const depthChanged = both && product.wd_depth !== compareProduct.wd_depth

    // TODO: perhaps compare the products and put both texts in ShortTexts
    const de =
      (product &&
        product.wd_texts &&
        product.wd_texts
          .slice(0, 19)
          .map((currentText, index) => ({
            id: index,
            currentText: currentText,
            newText:
              compareProduct &&
              compareProduct.wd_texts &&
              compareProduct.wd_texts[index],
            hasChanged:
              compareProduct &&
              compareProduct.wd_texts &&
              compareProduct.wd_texts[index] !== currentText,
          }))
          .filter((item) => item.currentText || item.newText)) ||
      []
    const fr =
      (product &&
        product.wd_texts &&
        product.wd_texts
          .slice(20, 39)
          .map((currentText, index) => ({
            id: index,
            currentText: currentText,
            newText:
              compareProduct &&
              compareProduct.wd_texts &&
              compareProduct.wd_texts[index + 20],
            hasChanged:
              compareProduct &&
              compareProduct.wd_texts &&
              compareProduct.wd_texts[index + 20] !== currentText,
          }))
          .filter((item) => item.currentText || item.newText)) ||
      []
    const width = widthChanged ? compareProduct.wd_width : product.wd_width
    const height = heightChanged ? compareProduct.wd_height : product.wd_height
    const depth = depthChanged ? compareProduct.wd_depth : product.wd_depth
    return (
      <div>
        <Header
          content={I18n.t('admin.productProperties.not_relevant')}
          dividing
          as="h3"
          color={product.kind === 'compare' ? 'orange' : 'black'}
        />
        <Form.Group widths="equal">
          <Form.Input
            readOnly
            fluid
            label="Breite"
            name="width"
            className={widthChanged ? 'changed' : ''}
            value={width ? width : ''}
          />
          <Form.Input
            readOnly
            fluid
            label="Höhe"
            name="height"
            className={heightChanged ? 'changed' : ''}
            value={height ? height : ''}
          />
          <Form.Input
            readOnly
            fluid
            label="Tiefe"
            name="depth"
            className={depthChanged ? 'changed' : ''}
            value={depth ? depth : ''}
          />
        </Form.Group>
        <Header
          content={
            product.kind === 'compare'
              ? I18n.t('admin.productProperties.title_compare')
              : I18n.t('admin.productProperties.title')
          }
          dividing
          as="h3"
          color={product.kind === 'compare' ? 'orange' : 'black'}
        />
        <Grid stackable>
          <Grid.Row>
            <Grid.Column
              largeScreen={12}
              widescreen={12}
              computer={6}
              tablet={6}>
              <ShortTexts
                shortTexts={de}
                form={form}
                targetField="newTextDe"
                compare={!!compareProduct}
                title={I18n.t('navigation.languages.de')}
              />
            </Grid.Column>

            <Grid.Column
              largeScreen={12}
              widescreen={12}
              computer={6}
              tablet={6}>
              <ShortTexts
                shortTexts={fr}
                form={form}
                targetField="newTextFr"
                kind={product.kind}
                title={I18n.t('navigation.languages.fr')}
                compare={!!compareProduct}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductPropertyWinDeltaTexts.jsx